import type { ButtonProps } from '@sravni/react-design-system/lib/Button';

import { sendEventButtonClick } from 'shared/lib/sendGAEvents';
import type { TOffer } from 'shared/types/TRankingService';

import { OfferButton } from '../OfferButton/OfferButton';

import styles from './MfoFinalButton.module.scss';
import { MFO_FINAL_TEXTS } from './MfoFinalButton.texts';

type Props = {
  offer: TOffer;
  buttonProps?: ButtonProps;
};

export const MfoFinalButton = ({ offer, buttonProps }: Props) => {
  const { buttonText = MFO_FINAL_TEXTS.LABEL } = offer?.additionalInfo || {};
  const { onClick: onClickProp, ...otherButtonProps } = buttonProps || {};

  const onClick = () => {
    if (offer?.buttonLink) {
      sendEventButtonClick(buttonText);
      window.location.href = offer?.buttonLink;
    }
  };

  return (
    <OfferButton
      {...otherButtonProps}
      className={styles.button}
      onClick={(event) => {
        event.stopPropagation();
        onClick();
        onClickProp?.(event);
      }}
    >
      {buttonText}
    </OfferButton>
  );
};
